import axios from 'axios';

const instance = axios.create({
  baseURL: "https://distfront.onrender.com",
  headers: {
    'Content-Type': 'application/json',
  }
});
// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists and is valid, add it to headers
    if (token && token !== 'undefined') {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 errors but don't redirect for public routes
    if (error.response?.status === 401 && !error.config.url.includes('projects')) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export default instance;